import { SectionsConfig, getMicrositeConfig } from 'api/MicrositeConfig/getMicrositeConfig';
import { Microsites } from 'constants/constants';
import EduSectionAndCategory, { getStaticProps } from '..';

export { getStaticProps };

export const getStaticPaths = async () => {
  if (process.env.TEST) {
    return {
      fallback: 'blocking',
      paths: [],
    };
  }

  const educationSections = (await getMicrositeConfig(Microsites.Education)).sections as SectionsConfig;

  const paths = Object.keys(educationSections).map((slug) => ({
    params: {
      pageNum: '2',
      section: slug,
    },
  }));

  return {
    fallback: 'blocking',
    paths,
  };
};

export default EduSectionAndCategory;
